module.exports = "<div class=\"container\">\n  <div class=\"center\">\n    <h5>{{message}}</h5>\n    <button class=\"btn cancel\" style=\"float:left\" routerLink=\"/\">Home</button>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/confirm/confirm.html
// module id = ./src/app/pages/confirm/confirm.html
// module chunks = main